import React, { useState, useRef, useEffect } from 'react';
import seagullSpeechBubble from '../../public/static/images/seagullSpeechBubble.png';
import { FAQ_ITEMS } from '../../constants';
import ArrowPagination from '../ArrowPagination';
import { useMediaQuery } from '../../hooks';

import styles from './index.module.scss';

const FAQ = () => {
  const { isLargeScreen } = useMediaQuery();
  const [currentIndex, setCurrentIndex] = useState(0);
  const carouselRef = useRef(null);
  const itemsRef = useRef({});
  const hasInitializedCarousel = useRef(false);

  const handlePrevious = () => {
    setCurrentIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => Math.min(FAQ_ITEMS.length - 1, prev + 1));
  };

  useEffect(() => {
    if (!hasInitializedCarousel.current) {
      hasInitializedCarousel.current = true;
      return;
    }

    if (!isLargeScreen && itemsRef.current[currentIndex]) {
      itemsRef.current[currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  }, [currentIndex, isLargeScreen]);

  return (
    <section id="faq" className={styles.section}>
      <header className={styles.header}>
        <h2 className={styles.title}>
          <img className={styles.icon} src={seagullSpeechBubble} alt="" />
          <div className={styles.titleText}>
            <span>BF Island: </span>
            <span>The Unserious FAQ</span>
          </div>
        </h2>
      </header>

      <div className={styles.carouselWrapper} ref={carouselRef}>
        <div className={styles.faqList}>
          {FAQ_ITEMS.map((item, index) => (
            <article
              ref={(el) => {
                if (el) itemsRef.current[index] = el;
              }}
              className={`${styles.item} ${!isLargeScreen && index !== currentIndex ? styles['item--inactive'] : ''}`}
              key={item.title}
            >
              <h3 className={styles.question}>{item.title}</h3>
              <p className={styles.answer}>{item.description}</p>
            </article>
          ))}
        </div>
      </div>
      {!isLargeScreen && (
        <ArrowPagination
          currentIndex={currentIndex}
          total={FAQ_ITEMS.length}
          onPrevious={handlePrevious}
          onNext={handleNext}
        />
      )}
    </section>
  );
};

export default FAQ;
